class DatetimeManager {
    constructor() {
        const pickers = $('.js-DatetimePicker');
        if (!pickers.length)
            return;
        (async () => {
            await import('../libraries/jquery-ui-datepicker'); // Make sure the datepicker in form-datepicker.ts is loaded
            pickers.each((index, elem) => {
                const datetimeField = $(elem);
                const field = datetimeField.closest('.Field');
                const timeField = field.find('.js-TimePicker');
                const dateField = field.find('.hasDatepicker');
                if (dateField.length !== 1 || timeField.length !== 1) {
                    console.error('The .js-DatetimePicker field is missing siblings .js-TimePicker and or .js-DatePicker');
                    console.warn('Date fields: ');
                    console.warn(dateField);
                    console.warn('Time fields: ');
                    console.warn(timeField);
                    return;
                }
                dateField.add(timeField).on('change blur', () => {
                    const date = dateField.val();
                    const time = timeField.val();
                    let datetime = date && time ? date + 'T' + time : '';
                    const form = datetimeField.closest('form');
                    if (form.length) {
                        const validator = form.data('validator');
                        if (validator) {
                            const dateValid = validator.element(dateField);
                            const timeValid = validator.element(timeField);
                            if (!dateValid || !timeValid)
                                datetime = '';
                        }
                    }
                    datetimeField.val(datetime).trigger('blur');
                });
            });
        })();
    }
}
const datetimeManager = new DatetimeManager();
export { DatetimeManager, datetimeManager };
